import useOperationTranslation from "../../../hooks/useOperationTranslation";
import FormInput from "../../common/FormInput";
import * as Mui from "@mui/material";
import { TransferReasonTypes } from "../Types";
import { Parser } from "../../../utils";

interface Props {
  transferRequest?: TransferReasonTypes.TransferRequestDetails;
}

const TransferRequest = (props: Props) => {
  const t = useOperationTranslation();
  return (
    <Mui.Card>
      <Mui.CardContent>
        <Mui.Grid
          container
          columns={12}
          alignItems="center"
          spacing={2.5}
          rowGap={4}
        >
          <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
            <FormInput
              name="requestNumber"
              label={t("transferReason.details.tab1.requestNumber")}
              value={props.transferRequest?.requestNumber || ""}
              type="text"
              disabled
              fullWidth
            />
          </Mui.Grid>

          <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
            <FormInput
              name="requestDate"
              label={t("transferReason.details.tab1.requestDate")}
              value={props.transferRequest?.requestDate || ""}
              type="date"
              disabled
              fullWidth
            />
          </Mui.Grid>

          <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
            <FormInput
              name="startStation"
              label={t("transferReason.details.tab1.startLocation")}
              value={props.transferRequest?.startStation || ""}
              type="text"
              disabled
              fullWidth
            />
          </Mui.Grid>

          <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
            <FormInput
              name="startDate"
              label={t("transferReason.details.tab1.startDate")}
              value={props.transferRequest?.startDate || ""}
              type="date"
              disabled
              fullWidth
            />
          </Mui.Grid>
		  
		  <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
            <FormInput
              name="realStartDate"
              label={t("transferReason.details.tab1.realStartDate")}
              value={props.transferRequest?.realStartDate || ""}
              type="date"
              disabled
              fullWidth
            />
          </Mui.Grid>

          <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
            <FormInput
              name="expectedEndLocation"
              label={t("transferReason.details.tab1.expectedEndLocation")}
              value={props.transferRequest?.expectedEndLocation || ""}
              type="text"
              disabled
              fullWidth
            />
          </Mui.Grid>

          <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
            <FormInput
              name="expectedEndDate"
              label={t("transferReason.details.tab1.expectedEndDate")}
              value={props.transferRequest?.expectedEndDate || ""}
              type="date"
              disabled
              fullWidth
            />
          </Mui.Grid>

          <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
            <FormInput
              name="endLocation"
              label={t("transferReason.details.tab1.endLocation")}
              value={props.transferRequest?.endLocation || ""}
              type="text"
              disabled
              fullWidth
            />
          </Mui.Grid>

          <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
            <FormInput
              name="endDate"
              label={t("transferReason.details.tab1.endDate")}
              value={props.transferRequest?.endDate || ""}
              type="date"
              disabled
              fullWidth
            />
          </Mui.Grid>

          <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
            <FormInput
              name="loadIndex"
              label={t("transferReason.details.tab1.loadIndex")}
              value={
                props.transferRequest?.loadIndex !== undefined
                  ? props.transferRequest?.loadIndex
                  : ""
              }
              type="number"
              disabled
              fullWidth
            />
          </Mui.Grid>

          <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
            <FormInput
              name="status"
              label={t("transferReason.details.tab1.status")}
              value={props.transferRequest?.status || ""}
              type="text"
              disabled
              fullWidth
            />
          </Mui.Grid>

          <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
            <FormInput
              name="routeKm"
              label={t("transferReason.details.tab1.routeKm")}
              value={
                props.transferRequest?.routeKm !== undefined
                  ? `${props.transferRequest?.routeKm} KM`
                  : ""
              }
              type="text"
              disabled
              fullWidth
            />
          </Mui.Grid>

          <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
            <FormInput
              name="reasonCode"
              label={t("transferReason.details.tab1.reasonCode")}
              value={props.transferRequest?.reasonCode || ""}
              type="text"
              disabled
              fullWidth
            />
          </Mui.Grid>

          <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
            <FormInput
              name="transferType"
              label={t("transferReason.details.tab1.transferType")}
              value={props.transferRequest?.transferType || ""}
              type="text"
              disabled
              fullWidth
            />
          </Mui.Grid>

          <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
            <FormInput
              name="deliveryNoteNumber"
              label={t("transferReason.details.tab1.deliveryNoteNumber")}
              value={props.transferRequest?.deliveryNoteNumber || ""}
              type="text"
              disabled
              fullWidth
            />
          </Mui.Grid>
          <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
            <FormInput
              name="operatorCode"
              label={t("transferReason.details.tab1.operatorCode")}
              value={props.transferRequest?.operatorCode || ""}
              type="text"
              disabled
              fullWidth
            />
          </Mui.Grid>
          <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
            <FormInput
              name="operatorCode"
              label={t("transferReason.details.tab1.operatorCodeApproval")}
              value={props.transferRequest?.operatorCodeApproval || ""}
              type="text"
              disabled
              fullWidth
            />
          </Mui.Grid>
          <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
            <FormInput
              name="operatorCode"
              label={t("transferReason.details.tab1.operatorCodeRejection")}
              value={props.transferRequest?.operatorCodeRejection || ""}
              type="text"
              disabled
              fullWidth
            />
          </Mui.Grid>
        </Mui.Grid>
      </Mui.CardContent>
    </Mui.Card>
  );
};

export default TransferRequest;
